// extracted by mini-css-extract-plugin
export default {"wrapper":"circularLoader_wrapper__iU2tD"};